import React, { useEffect } from 'react'
import Slider from './Slider/Slider'
import Menu from '../Menu/Menu'
import Service from './Service/Service'

const Signaletique = () => {

  useEffect(() => {
    window.scrollTo({
      top: 0,
      behavior: 'smooth'
    });
  })

  useEffect(() => {
    document.querySelector("title").textContent = "Loremedia - Panneaux de signalisation ";
  })

  return (
    <>

      <div style={{ height: "auto" }}>

        <Slider />

        <Menu/>

        <Service/>
        
      </div>

    </>
  )
}

export default Signaletique